export class User {
	additionalNotificationEmails: any[];
	allowCartCheckout: boolean;
	allowMapValidation: any;
	allowRecentOrders: boolean;
	allowRecentTemplates: boolean;
	allowedCustomers: any[];
	allowZeroPiecesOnOrders: boolean;
	approved: boolean;
	associatedDrivers: any[];
	canViewDriverPhoto: boolean; // not used in RS is same as displayDriverPhoto under globalSettings
	canViewOwnProfile: boolean;
	cancelOrderOption: string;
	companyName: string;
	customerName: string;
	cxtId: number;
	defaultCountry: string;
	defaultDestinationAddressId: number;
	defaultOriginAddressId: number;
	defaultServiceType: any;
	driverId: number;
	editOrderValue: string;
	email1: string;
	fieldSpecifications: [
		{
			name: string;
			required: boolean;
			min: number;
			max: number;
			defaultEntry: string;
			overrideLabel: string;
		},
		{
			name: string;
			required: boolean;
			min: number;
			max: number;
			defaultEntry: string;
			overrideLabel: string;
		},
		{
			name: string;
			required: boolean;
			min: number;
			max: number;
			defaultEntry: string;
			overrideLabel: string;
		},
		{
			name: string;
			required: boolean;
			min: number;
			max: number;
			defaultEntry: string;
			overrideLabel: string;
		},
		{
			name: string;
			required: boolean;
			min: number;
			max: number;
			defaultEntry: string;
			overrideLabel: string;
		},
		{
			name: string;
			required: boolean;
			min: number;
			max: number;
			defaultEntry: string;
			overrideLabel: string;
		},
		{
			name: string;
			required: boolean;
			min: number;
			max: number;
			defaultEntry: string;
			overrideLabel: string;
		},
		{
			name: string;
			required: boolean;
			min: number;
			max: number;
			defaultEntry: string;
			overrideLabel: string;
		},
		{
			name: string;
			required: boolean;
			min: number;
			max: number;
			defaultEntry: string;
			overrideLabel: string;
		}
	];
	firstName: string;
	friendlyName: string;
	globalSettings: {
		allowGuest: boolean;
		contactlessServiceRapidship: boolean;
		creditCardProcessingMethod: string;
		useCanadianAddressesByDefault: boolean;
		enableGooglePlacesSearch: boolean;
		enforceAddressValidation: boolean;
		allowUnknownDest: boolean;
		requirePiecesForOrders: boolean;
		requireWeightForOrders: boolean;
		defaultPieceCountForOrders: any;
		defaultWeightAmountForOrders: any;
		requireParcelTypeForOrders: boolean;
		customMessageForNullPickedup: string;
		customMessageForNullDelivered: string;
		displayAddressesOnOrderTrackingPage: boolean;
		dateFormat: string;
		timeDisplayFormat: string;
		inetMaxAttachmentSize: number;
		displayDriverPhoto: boolean;
		displayInvoices: boolean;
		displayReleaseInfo: boolean;
		customZipCodeNotFoundError: string;
		canCreateCustAccount: boolean;
		displayETA: boolean;
		releaseInfoLabel: string;
		isParcelEntryEnabled: boolean;
		isTextMessagingEnabled: boolean;
		driverLocationDisplayAccessibility: string;
		isQuickbooksEnabled: boolean;
		isPackageInfoRequired: boolean;
		isCentralizedSsoConfigured: boolean;
		ssoDomains: string[];
		trackingOptions: {
			isActive: boolean;
		};
		requirePhoneNumberClientPortal: boolean;
	};
	hideDeliverBy: boolean;
	hideItems: boolean;
	inetUser: {
		allowTrackOrder: boolean;
		id: string;
		custId: any;
		email: string;
		phone: string;
		friendlyName: string;
		hideRates: boolean;
		addressBookOnDemand: boolean;
		canViewShippingOptions: boolean;
		defaultServiceType: string;
		defaultBillingGroup: string;
		defaultReportType: string;
		accessorialCharges: boolean;
		allowDueTimeFrom: boolean;
		viewInvoices: boolean;
		addressBookLocked: boolean;
		billingGroupLocked: boolean;
		defaultpointIdOrigin: string;
		defaultpointIdDest: string;
		userAddressBookEnabled: boolean;
		useConsolidatedAddresses: boolean;
		addressBookGroup: string;
		shippingLabelId: any;
		viewRouteStops: boolean;
		miscData: any;
		modifyRouteStops: boolean;
		viewAccountReports: boolean;
		viewDetailTracking: boolean;
		creditCardUsage: any;
		allowPasswordChange: boolean;
		allowAddressBookAccess: boolean;
		filterInetUserDrivers: boolean;
		hideInactiveRouteStops: boolean;
		allowRateOverride: boolean;
		printShippingLabel: boolean;
		defaultAddressSearch: string;
		pushNotifications: {
			confirmed: boolean;
			arrived: boolean;
			pickedUp: boolean;
			delivered: boolean;
			eta: boolean;
		};
		defaultOrderTypeId: number;
		followCustomerOrderType: boolean;
		driverLocationDisplayAccessibility: string;
	};
	lastName: string;
	licenses: {
		xRouteEnabled: boolean;
	};
	localOffset: any;
	maxAttachmentSize: number;
	mobilePhone: string;
	parcelTypes: string;
	preferredDistanceUnit: string;
	primaryCustomerId: number;
	serviceTypes: [
		{
			id: number;
			description: string;
		}
	];
	showAddresses: boolean;
	showBaseAmount: boolean;
	showDriverSplit: boolean;
	showGroup: boolean;
	showNames: boolean;
	showOrderType: boolean;
	showPercentOrder: boolean;
	showPieces: boolean;
	showPrice: boolean;
	showReference: boolean;
	showTotalsOnly: boolean;
	showWeight: boolean;
	showZip: boolean;
	token: string;
	type: string;
	useConsolidatedAddresses: boolean;
	username: string;
	validateInetAddresses: boolean;
	featureFlags: any = {};
}
